import moment from "moment";

/**
 * Directive for blocking future dates
 *
 * @ngInject
 */
export default () => {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: ($scope, $element, $attributes, ngModel) => {
			ngModel.$parsers.unshift(function (value) {
				let defaultMask = "DD/MM/YYYY";

				if (!$attributes.noFutureDates)
					console.warn("no-future-dates directive: Missing moment.js date mask. Using default: DD/MM/YYYY");

				let today = new Date();
				let birthday = moment(value, $attributes.noFutureDates || defaultMask).toDate();

				let isFuture = birthday.getTime() > today.getTime();

				if (isFuture) {
					ngModel.$setValidity('isFutureDate', false);
					return undefined;
				} else {
					ngModel.$setValidity('isFutureDate', true);
					return birthday;
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/misc/directives/noFutureDates.directive.js